import { RouteTab, useRouteTabs } from 'custom_hooks/data_hooks/data_source/useRouteTabs';
import { ContentTabConfig, TabConfig } from 'custom_hooks/data_hooks/data_source/useTabs';
import { useMemo } from 'react';

export function useApprovedTabs() {
    const routeTabs = useRouteTabs(
        useMemo<TabConfig[]>(
            () => [
                {
                    id: 'approved',
                    label: 'Approved',
                },
                {
                    id: 'unapproved',
                    label: 'Unapproved',
                },
            ],
            []
        )
    );

    return {
        ...routeTabs,
        isApprovedTab: routeTabs.currentTab?.id !== 'unapproved',
    };
}

export function useTabComponent<TProps>({
    tabs,
    ContentComponent,
    props,
}: {
    tabs: RouteTab<TabConfig>[];
    ContentComponent: React.FC<TProps>;
    props: React.PropsWithChildren<TProps>;
}): RouteTab<ContentTabConfig>[] {
    return tabs.map((t) => ({
        ...t,
        content: <ContentComponent {...props} />,
    }));
}
